export default __webpack_public_path__ + "static/highlight-3-mobile-deb2ef43cc476893de52c90bb395fcf3.svg";